// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".select-year[data-v-bb67b130]{min-height:0;width:72px}", "",{"version":3,"sources":["webpack://./resources/assets/js/_painel_admin/components/global/AppCalendar/index.vue"],"names":[],"mappings":"AACA,8BAEE,YAAW,CADX,UACF","sourcesContent":["\n.select-year\n  width 72px\n  min-height 0\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
